import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";
import { IGetAllIndicadoresUseCase } from "../../../presentation/useCases/read/get_all_qualidade_indicadores_use_case";
import { IndicadoresFilter } from "../../models/indicadores_filter";
import { IndicadoresLista } from "../../models/indicadores_lista";


// GetAllQualidadeIndicadoresServicoUseCase


export class GetAllQualidadeIndicadoresServicoUseCase
  extends BasePaginatedUseCase<IndicadoresLista>
  implements IGetAllIndicadoresUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllListagemIndicadores(
    filter: IndicadoresFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    
    const response = await this.repository
      .getAllListagemIndicadores(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
